<template>
  <div class="product-campaign">
    <div class="product-campaign__img">
      <img
        class="product-campaign-desktop"
        v-if="campaignModel.stageImageDesktop"
        v-bind:src="campaignModel.stageImageDesktop.src"
      />
      <img
        class="product-campaign-mobile"
        v-if="campaignModel.stageImageMobile"
        v-bind:src="campaignModel.stageImageMobile.src"
      />
      <img
        class="product-campaign-tablet"
        v-if="campaignModel.stageImageTablet"
        v-bind:src="campaignModel.stageImageTablet.src"
      />
    </div>

    <div class="product-campaign__content">
      <div class="product-campaign__card">
        <div class="product-campaign__card-header">
          <div
            v-for="item in campaignModel.productPages"
            v-bind:key="item.comparisonData.id"
            class="product-campaign__card-header__title text-weight__bold"
            v-bind:class="{'title-selected':item.comparisonData.id ==currentProduct.comparisonData.id}"
            v-on:click="setProductEvent($event,item.comparisonData.id)"
          >{{item.comparisonData.product_Card_Headline}}</div>
        </div>
        <div class="product-campaign__card-content">
          <div class="product-campaign__card-content__feature">
            <div v-html="currentProduct.comparisonData.product_Card_Main_Features"></div>

            <div class="product-campaign__card-content__feature-pricebox text-center">
              <div
                class="product-campaign__card-content__feature-pricebox-price"
                v-html="productPrice.price_Card_Headline"
              ></div>
              <div
                class="product-campaign__card-content__feature-pricebox-text"
                v-html="productPrice.price_Card_Note"
              ></div>
            </div>
          </div>
          <div class="text-center">
            <a
              v-if="productPrice.price_Card_Button"
              class="button"
              :href="productPrice.price_Card_Button.url"
            >{{productPrice.price_Card_Button.text}}</a>
          </div>
          <div
            class="product-campaign__card-content-text text-center text-red"
            v-if="productPrice.price_Card_Product_Information_Link"
          >
            <a
              :href="productPrice.price_Card_Product_Information_Link.url"
            >{{productPrice.price_Card_Product_Information_Link.text}}</a>
          </div>
         <hr class="hr--grey"/>
          <div class="product-campaign__card-content__advanteges">
            <div class="text-weight__600 text-center" v-html="campaignModel.benefitsHeadline"></div>
            <div
              class="product-campaign__card-content__advanteges-selection text-center text-weight__bold"
            >
              <!-- feature will be displayed in advnateges and
              advantes will be displayed in option because of some editig mistakes-->
              <div
                v-if="currentProduct.comparisonData.product_Card_Features"
                v-html="campaignModel.advantagesHeadline"
                class="product-campaign__card-content__advanteges-selection__title"
                v-bind:class="{'title-selected':selectedOption.current==selectedOption.advantage}"
                v-on:click="selectedOption.current=selectedOption.advantage"
              ></div>
              <div
                v-if="currentProduct.comparisonData.product_Card_Advantages"
                v-html="campaignModel.optionsHeadline"
                class="product-campaign__card-content__advanteges-selection__title"
                v-bind:class="{'title-selected':selectedOption.current==selectedOption.option}"
                v-on:click="selectedOption.current=selectedOption.option"
              ></div>
            </div>
            <div
              v-if="selectedOption.current==selectedOption.advantage"
              v-html="currentProduct.comparisonData.product_Card_Features"
            ></div>
            <div
              v-if="selectedOption.current==selectedOption.option"
              v-html="currentProduct.comparisonData.product_Card_Advantages"
            ></div>
          </div>
          <div class="text-red text-center">
            <a :href="currentProduct.itemUrl">{{form.itemUrlText}}</a>
          </div>
          <hr class="hr--grey"/>
          <div
            v-if="priceInformation"
            v-html="priceInformation.price_Card_Headline"
            class="product-campaign__card-content__price"
          ></div>
        </div>
      </div>

      <div class="product-campaign__content-intro">
        <div class="intro__label text" v-html="campaignModel.subHeadline"></div>
        <div class="headline headline--secondary" v-html="campaignModel.headline"></div>
        <div class="intro__label text description" v-html="campaignModel.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../resources/Config.js";
export default {
  name: "ProductCampaign",
  data() {
    return {
      campaignModel: {},
      currentProduct: {},
      form: {},
      selectedOption: {
        current: 1,
        advantage: 1,
        option: 2
      }
    };
  },
  created() {
    this.campaignModel = config.productCampaign.campaignModel;
    this.form = config.productCampaign.form;
    this.setCurrentProduct(this.campaignModel.defaultProductPage);
  },
  computed: {
    productPrice() {
      return this.currentProduct.priceCards[0];
    },
    priceInformation() {
      return this.currentProduct.priceCards[1];
    }
  },

  methods: {
    setProductEvent($event, id) {
      this.setCurrentProduct(id);
    },
    setCurrentProduct(id) {
      if (!this.campaignModel.productPages) {
        return;
      }
      let product = this.campaignModel.productPages.find(
        item => item.comparisonData.id == id
      );
      if (!product) {
        product = this.campaignModel.productPages[0];
      }
      this.currentProduct = product;
      this.setDefaultOption();
    },
    setDefaultOption() {
      this.selectedOption.current = this.selectedOption.advantage;
      if (!this.currentProduct.comparisonData.product_Card_Features) {
        this.selectedOption.current = this.selectedOption.option;
      }
    }
  }
};
</script>


/* comment before building */
 <style lang="scss">


@import  '../../../../tpl-frontend/src/scss/_colors';
@import  '../../../../tpl-frontend/src/scss/_variables';
@import  '../../../../tpl-frontend/src/scss/_mixins';
@import  '../../../../tpl-frontend/src/templates/components/product-campaign/_product-campaign';
</style>

 